module.exports = __webpack_public_path__ + "static/media/footer-linear-light.75ee2c41.svg";